import { useEffect, useState } from "react"

export const CHAT_FOLDER_ALL_ID = 'all'
export const CHAT_FOLDER_STORAGE_KEY = 'chatSelectedFolderId'

export const useSelectedFolder = ({folders, loadedFolders}) => {
    const [selectedFolderId, setSelectedFolderId] = useState(() => {
        const folderIdFromStorage = localStorage.getItem(CHAT_FOLDER_STORAGE_KEY)
        return folderIdFromStorage || CHAT_FOLDER_ALL_ID
    })
 
    const setSelectedFolder = ({folderId = null}) => {
        if(!folderId) return;
        localStorage.setItem(CHAT_FOLDER_STORAGE_KEY, folderId)
        setSelectedFolderId(folderId)
    }

    useEffect(() => {
        if (selectedFolderId === CHAT_FOLDER_ALL_ID || !loadedFolders) return
        
        const hasSelectedFolder = folders.some((folder) => folder?.id === selectedFolderId)
        if (!hasSelectedFolder) {
            setSelectedFolderId(CHAT_FOLDER_ALL_ID)
            localStorage.removeItem(CHAT_FOLDER_STORAGE_KEY)
        }
    }, [folders, selectedFolderId, loadedFolders])

    return {
        selectedFolderId,
        setSelectedFolder
    }
}